import { DataSphereModule, GpmModule, PayrollModule, WymsModule } from '../../svgs/gpm';
import { GpmBlockWithImage } from '../../components/structures/gpm';
import { architecture } from '../../images/gpm';
import GpmArchitecture from '../../components/structures/gpm/GpmArchitecture';
import WhyUs from '../../components/structures/gpm/WhyUs';
import InterestedBlock from '../../components/structures/gpm/InterestedBlock';
import ModuleBlock from '../../components/structures/gpm/ModuleBlock';
import IndustriesServed from '../../components/structures/gpm/IndustriesServed';
import TechnologiesBlock from '../../components/structures/gpm/TechnologiesBlock';

const listWhyUs = [
  { title: '90%', text: 'Reduction in Reporting Errors' },
  { title: '5x', text: 'Faster Project Completion' },
  { title: '200%', text: 'Increase in Field Efficiency' },
  { title: 'Millions', text: 'Saved in Overbilling Prevention' },
];

const cards = [
  {
    title: 'Geospatial Intelligence for Real',
    icon: <GpmModule />,
    text: 'Real-time geolocation tracking, GPS-stamped field data, and centralized task visibility enable complete oversight across all phases of project delivery.',
  },
  {
    title: 'Accelerated Inventory Processing & Asset Control',
    icon: <WymsModule />,
    text: 'GPM’s WYMS optimizes inventory intake, fleet movement, and equipment availability across yards and staging areas.',
  },
  {
    title: 'Live Project Intelligence in One Hub',
    icon: <DataSphereModule />,
    text: 'All your project data—mapped, verified, and visualized in one place. Data Sphere is your centralized decision-making layer.',
  },
  {
    title: 'Proof-Based Billing & Compliance Automation',
    icon: <PayrollModule />,
    text: 'Built for financial accuracy, Payroll connects verified field data to structured billing and compliance workflows.',
  },
];

const categories = [
  {
    title: 'Construction & Civil Engineering',
    text: 'Centralized planning, design-to-execution tracking, and BIM-ready workflows for complex infrastructure builds.',
    link: '/gpm/construction',
  },
  {
    title: 'OSP (Outside Plant) Construction',
    text: 'From route planning to final audits—track design, deployment, permitting, and documentation in one interface.',
    link: '/gpm/osp',
  },
  {
    title: 'Fulfillment Services & Subcontractor Management',
    text: 'Assign tasks, track submissions, and verify billing across multi-vendor subcontracting ecosystems.',
    link: '/gpm/fulfillment-services',
  },
  {
    title: 'Power Grid & Renewable Energy Deployment',
    text: 'Coordinate solar, wind, battery, and grid infrastructure using real-time workforce and material tracking tools.',
    link: '/gpm/power-grid',
  },
  {
    title: 'Forestry Management & Logging Operations',
    text: 'Gain visibility into harvesting routes, regulatory documentation, and on-site proof-based reporting.',
    link: '/gpm/forestry-management',
  },
  {
    title: 'Mining & Extraction Operations',
    text: 'Monitor equipment status, worker allocation, and safety compliance across vast resource zones with real-time maps.',
    link: '/gpm/mining',
  },
];

const Gpm = () => {
  return (
    <>
      <GpmBlockWithImage
        title={'Geolocation Program Management (GPM)'}
        description={
          'GPM is a geospatial project management solution built by US Software Solutions to streamline how telecom, fiber, and utility networks are designed, deployed, and maintained. With full visibility across every project phase, GPM empowers teams to boost efficiency, reduce costs, and ensure compliance—on time, every time.'
        }
        subTitle={'Automating Infrastructure Projects Across Telecom and Utilities'}
        hasButton
        hasSvg
      />
      <IndustriesServed categories={categories} />
      <GpmArchitecture
        title={'GPM Architecture'}
        description={
          'GPM is built on a flexible, multi-layered architecture that brings together industry-standard GIS and CAD tools into one unified platform. It enables real-time mapping, spatial analytics, and project visualization across devices—ensuring every stakeholder works with the same live data.'
        }
        subtitle={'Seamlessly Integrated, Fully Scalable, and Geospatially Intelligent'}
        image={architecture}
      />
      <TechnologiesBlock />
      <ModuleBlock title={'Modules'} listItems={cards} />
      <WhyUs list={listWhyUs} title={'Why GPM?'} description={'To learn more about GPM features check out GPMGIS.COM website'} />
      <InterestedBlock title={'Are You Interested?'} />
    </>
  );
};

export default Gpm;
